<script setup lang="ts">
import { computed } from 'vue';
import { FormDependencyTypes } from '@shared/common/form/form.dependency-types';
import { container } from '@shared/common/dependency-injection/domain/container';
import type { FormFieldTranslatedPropertyComponent } from '@shared/common/form/application/component/translated/form-field-translated-property-component.types';
import FormFieldMessages from '@shared/common/form/application/component/FormFieldMessages.vue';
import type { TranslatedPropertyFormField } from '@shared/common/form/domain/form/field/translated-property.form-field';
import type { TranslatedProperty } from '@shared/common/translation/domain/model/translated-property.model';

const model = defineModel<TranslatedPropertyFormField<TranslatedProperty>>({ required: true });
const component = container.get<FormFieldTranslatedPropertyComponent>(
  FormDependencyTypes.FormFieldTranslatedPropertyComponent,
);

const hasError = computed(() => !!model.value.errorMessages?.length);
</script>

<template>
  <div>
    <component
      :is="component"
      :id="model.id"
      v-model="model.value"
      :label="model.label"
      :hint="model.hint"
      :placeholder="model.placeholder"
      :required="model.required"
      :disabled="model.disabled"
      :readonly="model.readonly"
      :has-error="hasError"
      :widget="model.widget"
    />
    <FormFieldMessages :errors="model.errorMessages" />
  </div>
</template>
